<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="530px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                    <el-form-item   prop="title" label="名称">
                        <el-input v-model="form.title" maxlength="50" style="width:365px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="scoreType" label="评分类型">
                        <el-select v-model="form.scoreType" clearable @change="changeScoreType" style="width:365px;">
                            <el-option
                                v-for="item in scoreTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item   prop="" label="五育评比设置" v-if="form.scoreType == 1">
                        <div border style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);width:365px;">
                            <el-checkbox v-for="module in moduleArr" :key="module.id"  v-model="form.rateSet" :label="module.id" border size="medium" style="margin:5px;">
                                {{module.name}}
                            </el-checkbox>
                        </div>
                    </el-form-item>

                    <el-form-item   prop="" label="复合评比设置" v-if="form.scoreType == 2">
                        <div border style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);width:365px;">
                            <el-checkbox v-for="module in moduleArr" :key="module.id"  v-model="form.rateSet" :label="module.id" style="margin:5px;">
                                {{module.moduleTitle}}
                                <span v-if="module.moduleTitle.indexOf(studentModule)>-1">
                                     表扬<el-input type="number" v-model="module.praise" placeholder="请输入百分比" style="width:80px;"></el-input>%
                                    ，待改进<el-input type="number" v-model="module.improve" placeholder="请输入百分比" style="width:80px;"></el-input>%
                                </span>
                                <span v-else>
                                    <el-input type="number" v-model="module.inputVal" placeholder="请输入百分比" style="width:260px;"></el-input>%
                                </span>
                            </el-checkbox>
                        </div>
                    </el-form-item>

                    <el-form-item   prop="" label="梯度制分数">
                         <el-Checkbox v-model="form.gradientSwitch"></el-Checkbox>
                    </el-form-item>

                    <el-form-item   prop="rangeSet" label="评比范围">
                        <el-cascader style="width:365px;"
                            :options="classes"
                            v-model="form.rangeSet"
                            :props="props"
                            collapse-tags
                            clearable>
                        </el-cascader>
                    </el-form-item>

                    <el-form-item   prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" maxlength="2" type="number" style="width:80px;"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 

    export default {
        data(){
            return{
                visible: false,
                props: {multiple: true,  checkStrictly: true },
                form:{
                    deptId:"",
                    title:"",
                    scoreType:"",
                    rateSet:[],
                    rangeSet:"",
                    gradientSwitch:false,
                    orderNum:""
                },
                rules: {
                    title: [
                        { required: true, message: '请输入名称', trigger: 'blur' }
                    ],
                    scoreType: [
                        { required: true, message: '请选择评分类型', trigger: 'blur' }
                    ],
                    rangeSet: [
                        { required: true, message: '请选择评比范围', trigger: 'blur' }
                    ]
                },
                scoreTypes:[
                    {
                        'value':1,
                        'label':'五育项目'
                    },{
                        'value':2,
                        'label':'复合积分'
                    },{
                        'value':3,
                        'label':'红领巾争章'
                    }
                ],
                moduleArr:[],
                classes:[],
                studentModule:"学生评价"
            }
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.gradientSwitch = false;
                this.form.deptId=deptId;
                this.moduleArr=[];
                // 获取评比范围
                this.getDeptCascader();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            //获取评比范围
            getDeptCascader(){
                let url  = this.getDeptCascaderUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                      this.classes = res.data.selects; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        
                        // 评比设置-评分类型（1-五育项目，2-复合积分）
                        let rateSet="";
                        if(this.form.scoreType == 1){
                            if(this.form.rateSet.length == 0){
                                this.$commonFn.showTip('五育评比设置不可为空',3);
                                return;
                            }
                            let val=new Array();
                            for(let j=0;j<this.form.rateSet.length;j++){
                                let obj={};
                                obj.id=this.form.rateSet[j];
                                val.push(obj);
                            }
                            rateSet=JSON.stringify(val);
                        }else if(this.form.scoreType == 2){
                            if(this.form.rateSet.length == 0){
                                this.$commonFn.showTip('复合评比设置不可为空',3);
                                return;
                            }
                            let val=new Array();
                            for(let j=0;j<this.form.rateSet.length;j++){
                                let obj={};
                                let moduleId=this.form.rateSet[j];
                                for(let i=0;i<this.moduleArr.length;i++){
                                    if(moduleId === this.moduleArr[i].id){
                                        // 学生评价模块，表扬与待改进。
                                        if(this.moduleArr[i].moduleTitle === this.studentModule){
                                            if((this.moduleArr[i].praise == null || this.moduleArr[i].praise == '')
                                                || (this.moduleArr[i].improve == null || this.moduleArr[i].improve == '')){
                                                this.$commonFn.showTip("已选中的评比项百分比不能为空",3);
                                                return;
                                            }else if((this.moduleArr[i].praise<0 || this.moduleArr[i].praise>100)
                                                || (this.moduleArr[i].improve<0 || this.moduleArr[i].improve>100)){
                                                this.$commonFn.showTip("百分比只能在1-100之间设置",3);
                                                return;
                                            }
                                            obj.praise=this.moduleArr[i].praise;
                                            obj.improve=this.moduleArr[i].improve;
                                        }else {
                                            if(this.moduleArr[i].inputVal == null || this.moduleArr[i].inputVal == ''){
                                                this.$commonFn.showTip("已选中的评比项百分比不能为空",3);
                                                return;
                                            }else if(this.moduleArr[i].inputVal<0 || this.moduleArr[i].inputVal>100){
                                                this.$commonFn.showTip("百分比只能在1-100之间设置",3);
                                                return;
                                            }
                                            obj.rate=this.moduleArr[i].inputVal;
                                        }
                                        obj.id=moduleId;
                                        val.push(obj);
                                        break;
                                    }
                                }
                            }
                            rateSet=JSON.stringify(val);
                        }

                        // 评比范围
                        let rangeSet=new Array();
                        for(let i=0;i<this.form.rangeSet.length;i++){
                            let obj=this.form.rangeSet[i];
                            rangeSet.push(obj[this.form.rangeSet[i].length-1]);
                        }
                        // 提交后台保存
                        let url= this.honorSetSavetUrl;
                        let data = {
                            deptId:this.form.deptId,
                            honorTarget:2, // 荣誉目标（1-班级，2-学生）
                            title:this.form.title,
                            scoreType:this.form.scoreType,
                            rateSet:rateSet,
                            rangeSet:rangeSet.join(),
                            gradientSwitch:this.form.gradientSwitch,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            },
            changeScoreType(){
                this.moduleArr=[];
                this.form.rateSet=[];
                // 评分类型（1-五育项目，2-复合积分）
                if(this.form.scoreType == 1){
                    this.getEvaluateType();
                }else if(this.form.scoreType == 2){
                    this.getTaskModule();

                }
            },
            // 获取五育类型
            getEvaluateType(){
                let url  = this.evaluateTypeListUrl;
                let data = {deptId:this.form.deptId};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.moduleArr=res.data.list;
                        return;
                    }
                    this.$commonFn.showTip(res.message,3);
                    this.moduleArr=[];
                },(err)=>{
                    console.log(err);
                });
            },
            // 获取任务关联模块
            getTaskModule(){
                let url  = this.moduleConfigListAddGroupUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.moduleArr=res.data;
                        return;
                    }
                    this.$commonFn.showTip(res.message,3);
                    this.moduleArr=[];
                },(err)=>{
                    console.log(err);
                    this.$commonFn.showTip(err,3);
                });
            },
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/AddStudentEvaluate.vue